import { Formik } from "formik";
import TabsSection from "./sections/tabs";
import { Container, Divider } from "@mui/material";
import PageHeader from "components/Shared/PageHeader";
import InfoSection from "./sections/info";
import InstallmentsList from "./sections/list";
import Settings from "./sections/settings/settings";
import Footer from "./sections/footer";
import CreateInstallmentsRows from "./sections/create";
import { DateToString } from "components/Reports/DateFilter";
import CalculateInstalment from "./sections/settings/calculateInstalment";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { apiGetInstallment } from "api/installmentApi";
import { useAppSelector } from "../../store/store";

export default function InstallmentForm() {
  const dispatch = useDispatch();
  const store = useAppSelector((x: any) => x);
  const token = store.businessReducer.business.token;
  const [initialFormData, setInitialFormData] = useState<any>();
  const [load, setLoad] = useState(true);
  const init: InstallmentData = {
    date: DateToString(new Date(Date.now())),
    installmentsFirstRepayDate: DateToString(new Date(Date.now())),
  };

  const { id } = useParams() ?? { id: undefined };
  useEffect(() => {
    if (id) {
      initialData();
    } else {
      setInitialFormData(init);
      setLoad(false);
    }

    return () => {};
  }, [id]);

  const initialData = async () => {
    dispatch(
      //@ts-ignore
      apiGetInstallment(id, token, (data: any) => {
        try {
          if (data?.profitSettings) {
            let newData = JSON.parse(data.profitSettings);
            if (typeof newData === "string") {
              setInitialFormData(JSON.parse(newData));
            } else {
              setInitialFormData(newData);
            }
          }
        } catch (error) {
          console.log("*-*-*--", error);
          setInitialFormData(init);
        }
        setLoad(false);
      })
    );
  };

  return (
    <>
      {!load && (
        <Formik initialValues={initialFormData} onSubmit={() => {}}>
          <Container className="relative px-2 md:px-4">
            <PageHeader heading="ایجاد اقساط" />
            <div className="mb-12 bg-white rounded-md">
              <TabsSection />
              <Divider className="mb-4 border-1" />
              <div className="px-2 py-6 md:px-10">
                <InfoSection />
              </div>
              <Divider className="" />

              <div className="px-2 md:px-10">
                <CreateInstallmentsRows />
                <Settings />
                <CalculateInstalment />
              </div>
            </div>

            <div className="bg-white rounded-md ">
              <div className="px-2 py-6 md:px-10">
                <InstallmentsList />
              </div>
            </div>

            <Footer id={id} />
          </Container>
        </Formik>
      )}
    </>
  );
}
